import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DataTable from "primevue/datatable";
import Column from "primevue/column";

import moment from "moment";

import {inject, onMounted, ref} from "vue";
import {AxiosStatic} from "axios";

// Define injects

export default /*#__PURE__*/_defineComponent({
  __name: 'ListRemoteWritersTable',
  setup(__props, { expose }) {


const axios = inject<AxiosStatic>('axios')

// Define properties
const items = ref<any[]>([])
const loading = ref<boolean>(true)
const dt = ref(null);
const pageIndex = ref<number>(0)
const pageSize = ref<number>(25)
const totalRecords = ref<number>(0)

// Define lifecycle hooks
onMounted(() => {
  loadData()
})

// Define methods
function loadData(filterData: any = {}) {
  loading.value = true
  axios?.get("/remote-writer/list")
      .then((response) => {
        if (response.status === 200) {
          items.value = response.data
        }
        totalRecords.value = response.data.length
        loading.value = false
      }).catch(error => {
    console.error('Can not load writers settings', error)
    loading.value = false
  })
}

function reload() {
  loadData()
}

expose({reload})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    page: pageIndex.value+1,
    ref_key: "dt",
    ref: dt,
    dataKey: "id",
    value: items.value,
    paginator: true,
    rows: pageSize.value,
    totalRecords: totalRecords.value,
    filterDisplay: "row",
    loading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        field: "id",
        header: "ID"
      }),
      _createVNode(_unref(Column), {
        field: "keyPattern",
        header: "PATTERN"
      }),
      _createVNode(_unref(Column), {
        field: "remoteWriterList",
        header: "WRITERS"
      }),
      _createVNode(_unref(Column), {
        field: "description",
        header: "NOTE"
      })
    ]),
    _: 1
  }, 8, ["page", "value", "rows", "totalRecords", "loading"]))
}
}

})